export var FolderType = /*#__PURE__*/ function(FolderType) {
    FolderType["PAID"] = "paid";
    FolderType["WATCHERS"] = "watchers";
    FolderType["REGULAR"] = "regular";
    return FolderType;
}({});

//# sourceMappingURL=types.js.map